import React, { Component } from 'react';
import './styles.css';

class label extends Component {
	render() {
		return <div className="submission-stepper-layout-label">Submission</div>;
	}
}

export default label;
